import * as TargetAudiencesEffects from './tip.effect';

export const effects = { ...TargetAudiencesEffects };
